// extracted by mini-css-extract-plugin
export default {"layout":"Login_layout__OmeL+","form":"Login_form__UrMgx","button":"Login_button__NslsQ"};